import { Icon } from '@manychat/icons'

import { FlowChartAttachment } from 'common/builder/components/chart/FlowChart/types/FlowChartAttachment'
import {
  FlowChartBlock,
  FlowChartBlockType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { FlowChartImagePreview } from 'common/builder/components/chart/FlowChart/types/FlowChartImagePreview'

export enum MediaMessageBodyType {
  TEXT = 'text',
  TEXT_WITH_ICON = 'text_with_icon',
}

export interface MediaMessageTextBody {
  type: MediaMessageBodyType.TEXT
  text: string
}

export enum MessageBodyDirection {
  ROW,
  COLUMN,
}

export interface MediaMessageTextWithIconBody {
  type: MediaMessageBodyType.TEXT_WITH_ICON
  text: string
  icon: Icon | null
  iconColor: string | null
  direction: MessageBodyDirection | null
}

export interface FlowChartMediaMessageBlock extends FlowChartBlock {
  type: FlowChartBlockType.MEDIA_MESSAGE
  data: {
    attachment: FlowChartAttachment | null
    preview: FlowChartImagePreview | null
    body: MediaMessageTextBody | MediaMessageTextWithIconBody | null
    buttons: FlowChartButton[]
  }
}
